export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  apiGateway: {
    URL: 'https://tv92otdsa6.execute-api.us-west-2.amazonaws.com/prod',
  },
  s3: {
    BUCKET: 'notes-app-uploads-west'
  },
  cognito: {
    USER_POOL_ID : 'us-west-2_5M95lDWKj',
    APP_CLIENT_ID : '68d4pn4iqkpof9uf7sligj5q2r',
    REGION: 'us-west-2',
    IDENTITY_POOL_ID: 'us-west-2:8baa986c-1710-4917-9f66-2385193788f3'
  }
};



// WEBPACK FOOTER //
// ./src/config.js